import React from 'react';

import _ from 'lodash';
import PropTypes from 'prop-types';

import request, {
  isAdmin,
  isSalesRep,
  isSalesManager,
  isSalesSupport
} from '../../../utils/request';
import Locked from './Locked';

import { salesRepActions, salesSupportActions } from './utils/getActions';

const Actions = ({ order, status, fetchOrders }) => {
  const { isLockedBy } = order;
  const { email } = request.getProfile();

  let selectedAction = [];
  if (isSalesRep || isAdmin) {
    selectedAction = salesRepActions;
  } else if (isSalesSupport || isAdmin || isSalesManager) {
    selectedAction = salesSupportActions;
  }

  return (
    <>
      {isLockedBy && isLockedBy !== email ? (
        <Locked />
      ) : (
        _.get(selectedAction, status, []).map(Action => (
          <Action status={status} orderData={order} fetchOrders={fetchOrders} />
        ))
      )}
    </>
  );
};

Actions.propTypes = {
  order: PropTypes.objectOf(PropTypes.object).isRequired,
  status: PropTypes.string.isRequired,
  fetchOrders: PropTypes.func.isRequired
};

export default Actions;
